// Import and register all your controllers from the importmap under controllers/*

import { application } from 'stimulus/application'
import { definitionsFromContext } from '@hotwired/stimulus-webpack-helpers'

const context = require.context('./controllers', true, /\.js$/)
application.load(definitionsFromContext(context))
